import * as React from 'react';
import get from 'lodash/get';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {
  CategoryCardLayout,
  ListingPaginatedLayout,
  CategoryCardLayoutProps,
  ListingPaginatedLayoutProps,
} from 'components/Marketplace';
import * as locales from './locales';

export interface ShopsProps extends ListingPaginatedLayoutProps, CategoryCardLayoutProps {
  categoriesPath: string;
}

function ShopsComponent({
  shops,
  sortBy,
  filters,
  paginationPath,
  categoryId,
  pagination,
  sortOptions,
  showFilters,
  filtersInUrl,
  shopsCountString,
  defaultSortOption,
  representFilterStateInURL,
  categories,
  categoriesPath,
  i18n,
}: ListingPaginatedLayoutProps & CategoryCardLayoutProps & ShopsProps & WithI18nProps) {
  const homepageCategories = get(categories, 'data.homepageCategories', []);
  const showCategories = homepageCategories && homepageCategories.length > 0;

  return (
    <>
      <ListingPaginatedLayout
        shops={shops}
        sortBy={sortBy}
        filters={filters}
        paginationPath={paginationPath}
        categoryId={categoryId}
        pagination={pagination}
        sortOptions={sortOptions}
        showFilters={showFilters}
        filtersInUrl={filtersInUrl}
        shopsCountString={shopsCountString}
        defaultSortOption={defaultSortOption}
        showSort={showFilters}
        representFilterStateInURL={representFilterStateInURL}
      />
      {showCategories && (
        <CategoryCardLayout
          heading={i18n.translate('categories.heading')}
          subhead={i18n.translate('categories.subhead')}
          categories={homepageCategories}
          ctaPath={categoriesPath}
          cta={i18n.translate('categories.cta')}
        />
      )}
    </>
  );
}

export const Shops = withI18n({
  id: 'Shops',
  fallback: locales.en,
})(ShopsComponent);
